import React, { createContext, useContext, useEffect, useState } from 'react';

import callApi from '../utils/callApi';
import { CATEGORY_LIST_URL } from '../constants/apiUrls/apiUrls';


const BlogContext = createContext({ categories: {} });

export const BlogProvider = ({ children }) => {
  const [categories, setCategories] = useState({});

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async() => {
    callApi(CATEGORY_LIST_URL, 'get', {}).then((res) => {
      setCategories(res.data.reduce((categories, category) => {
        return {
          ...categories,
          [category.id]: category.name,
        };
      }, {}));
    });
  };

  return (
    <BlogContext.Provider value={{ categories }}>
      {children}
    </BlogContext.Provider>
  );
};

export const useBlog = () => {
  const { categories } = useContext(BlogContext);

  return { categories };
};
